const message = {
  selectedTextAdvanced: "已选",
  pleaseSelect: "请选择",
  pleaseInput: "请输入",
  search: "搜索",
  maxSelectedCount: "最多选择{count}个",
  customTime: "自定义时间",
  monthly: "按月",
  weekly: "按周",
  all: "全部",
  items: "项",
  selectAll: "选择{label}",
};

export default message;
